import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faCrown, 
  faCalendarAlt, 
  faCalendarCheck, 
  faCalendar, 
  faCreditCard, 
  faFileInvoice, 
  faCog,
  faChevronLeft,
  faCheck,
  faTimes,
  faRocket,
  faStar
} from '@fortawesome/free-solid-svg-icons';
import './planulTau.css';

const PlanulTau = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [subscriptionData, setSubscriptionData] = useState(null);

  useEffect(() => {
    fetchUserData();
    fetchSubscriptionData();
  }, []);

  const fetchUserData = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/user`, {
        credentials: 'include'
      });
      
      if (response.ok) {
        const data = await response.json();
        setUserData(data);
      }
    } catch (error) {
      console.error('Eroare la incarcarea datelor:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchSubscriptionData = async () => {
    // Aici vei adauga logica pentru a prelua datele de abonament
    // Deocamdata folosim date mock
    setSubscriptionData({
      plan: 'PERSONAL',
      status: 'active',
      startDate: '01/12/2024',
      endDate: '01/12/2025',
      nextBilling: '02/12/2024',
      paymentMethod: 'Card •••• 1234',
      price: '49.99'
    });
  };

  const handleCancelSubscription = async () => {
    if (window.confirm('Esti sigur ca vrei sa anulezi abonamentul? Vei pierde accesul la toate cursurile premium.')) {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/subscription/cancel`, {
          method: 'POST',
          credentials: 'include'
        });
        
        if (response.ok) {
          alert('Abonamentul a fost anulat cu succes.');
          fetchSubscriptionData();
        } else {
          alert('A aparut o problema. Te rugam sa incerci din nou.');
        }
      } catch (error) {
        console.error('Eroare:', error);
        alert('A aparut o eroare. Te rugam sa incerci din nou mai tarziu.');
      }
    }
  };

  const handleDownloadInvoice = () => {
    // Logica pentru descarcarea facturii
    alert('Functionalitatea de descarcare factura va fi implementata curand.');
  };

  const handleUpgradePlan = () => {
    // Redirect catre pagina de upgrade
    alert('Functionalitatea de upgrade va fi implementata curand.');
  };

  if (loading) {
    return (
      <div className='planul-tau-container'>
        <div className='loading-message'>Se incarca...</div>
      </div>
    );
  }

  return (
    <div className='planul-tau-container'>
      {/* Header */}
      <div className='planul-tau-header'>
        <button className='btn-back' onClick={() => navigate('/settings')}>
          <FontAwesomeIcon icon={faChevronLeft} />
          <span>Inapoi la Setari</span>
        </button>
        <h1 className='planul-tau-title'>Planul tau</h1>
        <p className='planul-tau-subtitle'>Gestioneaza abonamentul si detaliile de plata</p>
      </div>

      {/* Content */}
      <div className='planul-tau-content'>
        
        {/* Card principal - Plan curent */}
        <div className='current-plan-card'>
          <div className='plan-header-section'>
            <div className='plan-badge-large'>
              <FontAwesomeIcon icon={faCrown} className='crown-icon-large' />
              <div className='plan-info'>
                <h2>Plan {subscriptionData?.plan}</h2>
                <span className='plan-price'>{subscriptionData?.price} RON / luna</span>
              </div>
            </div>
            <div className={`status-badge ${subscriptionData?.status}`}>
              <FontAwesomeIcon icon={faCheck} />
              Activ
            </div>
          </div>

          {/* Beneficii plan */}
          <div className='plan-benefits'>
            <h3>Beneficiile tale</h3>
            <div className='benefits-grid'>
              <div className='benefit-item'>
                <FontAwesomeIcon icon={faCheck} className='benefit-icon' />
                <span>Acces la toate cursurile</span>
              </div>
              <div className='benefit-item'>
                <FontAwesomeIcon icon={faCheck} className='benefit-icon' />
                <span>Diploma digitala</span>
              </div>
              <div className='benefit-item'>
                <FontAwesomeIcon icon={faCheck} className='benefit-icon' />
                <span>Suport prioritar 24/7</span>
              </div>
              <div className='benefit-item'>
                <FontAwesomeIcon icon={faCheck} className='benefit-icon' />
                <span>Continut exclusiv</span>
              </div>
            </div>
          </div>

          {/* Detalii abonament */}
          <div className='subscription-details'>
            <h3>Detalii abonament</h3>
            <div className='details-grid'>
              <div className='detail-row'>
                <div className='detail-icon-wrapper'>
                  <FontAwesomeIcon icon={faCalendarAlt} />
                </div>
                <div className='detail-info'>
                  <span className='detail-label'>Data de start</span>
                  <span className='detail-value'>{subscriptionData?.startDate}</span>
                </div>
              </div>

              <div className='detail-row'>
                <div className='detail-icon-wrapper'>
                  <FontAwesomeIcon icon={faCalendarCheck} />
                </div>
                <div className='detail-info'>
                  <span className='detail-label'>Valabil pana la</span>
                  <span className='detail-value'>{subscriptionData?.endDate}</span>
                </div>
              </div>

              <div className='detail-row'>
                <div className='detail-icon-wrapper'>
                  <FontAwesomeIcon icon={faCalendar} />
                </div>
                <div className='detail-info'>
                  <span className='detail-label'>Urmatoarea facturare</span>
                  <span className='detail-value'>{subscriptionData?.nextBilling}</span>
                </div>
              </div>

              <div className='detail-row'>
                <div className='detail-icon-wrapper'>
                  <FontAwesomeIcon icon={faCreditCard} />
                </div>
                <div className='detail-info'>
                  <span className='detail-label'>Metoda de plata</span>
                  <span className='detail-value'>{subscriptionData?.paymentMethod}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Actiuni */}
          <div className='plan-actions'>
            <button className='btn-primary' onClick={handleDownloadInvoice}>
              <FontAwesomeIcon icon={faFileInvoice} />
              Descarca factura
            </button>
            <button className='btn-secondary' onClick={handleUpgradePlan}>
              <FontAwesomeIcon icon={faRocket} />
              Upgrade plan
            </button>
          </div>
        </div>

        {/* Card - Metoda de plata */}
        <div className='payment-method-card'>
          <h3>
            <FontAwesomeIcon icon={faCreditCard} />
            Metoda de plata
          </h3>
          <div className='payment-card-display'>
            <div className='card-info'>
              <div className='card-number'>•••• •••• •••• 1234</div>
              <div className='card-details'>
                <span>Expira: 12/26</span>
                <span>VISA</span>
              </div>
            </div>
            <button className='btn-edit-payment'>
              <FontAwesomeIcon icon={faCog} />
              Modifica
            </button>
          </div>
        </div>

        {/* Card - Istoric facturi */}
        <div className='invoices-card'>
          <h3>
            <FontAwesomeIcon icon={faFileInvoice} />
            Istoric facturi
          </h3>
          <div className='invoices-list'>
            <div className='invoice-item'>
              <div className='invoice-info'>
                <span className='invoice-date'>Decembrie 2024</span>
                <span className='invoice-amount'>49.99 RON</span>
              </div>
              <button className='btn-download-small'>
                <FontAwesomeIcon icon={faFileInvoice} />
                Descarca
              </button>
            </div>
            <div className='invoice-item'>
              <div className='invoice-info'>
                <span className='invoice-date'>Noiembrie 2024</span>
                <span className='invoice-amount'>49.99 RON</span>
              </div>
              <button className='btn-download-small'>
                <FontAwesomeIcon icon={faFileInvoice} />
                Descarca
              </button>
            </div>
            <div className='invoice-item'>
              <div className='invoice-info'>
                <span className='invoice-date'>Octombrie 2024</span>
                <span className='invoice-amount'>49.99 RON</span>
              </div>
              <button className='btn-download-small'>
                <FontAwesomeIcon icon={faFileInvoice} />
                Descarca
              </button>
            </div>
          </div>
        </div>

        {/* Card - Anulare abonament */}
        <div className='cancel-subscription-card'>
          <h3>
            <FontAwesomeIcon icon={faTimes} />
            Anulare abonament
          </h3>
          <p className='cancel-description'>
            Daca anulezi abonamentul, vei pierde accesul la toate beneficiile premium la sfarsitul perioadei de facturare curente.
          </p>
          <button className='btn-cancel-subscription' onClick={handleCancelSubscription}>
            <FontAwesomeIcon icon={faTimes} />
            Anuleaza abonamentul
          </button>
        </div>

      </div>
    </div>
  );
};

export default PlanulTau;
